import { Link } from 'react-router-dom'
import Siren from 'screens/Noticeboard/components/Siren'
import useLastUnreadNotice from 'screens/Noticeboard/hooks/useLastUnreadNotice'
import styled from 'styled-components'

type NoticeboardItemProps = {
  isNoticeboardPath: boolean
}

export const NoticeboardItem = ({
  isNoticeboardPath
}: NoticeboardItemProps) => {
  const { isLoading, result: hasLastUnreadNotice } = useLastUnreadNotice()

  return (
    <StyledLink
      $isNoticeboardPath={isNoticeboardPath}
      to="noticeboard"
      data-cy="nav-btn-notice-board"
    >
      <Siren
        hasUnreadNotes={isLoading ? false : !!hasLastUnreadNotice}
        isNoticeboardPath={isNoticeboardPath}
      />
    </StyledLink>
  )
}

const StyledLink = styled(Link)<{ $isNoticeboardPath: boolean }>`
  display: flex;
  align-items: center;
  border-radius: 5px;
  margin-left: -12px;
  width: 48px;
  height: 48px;
  justify-content: center;
  margin-right: 15px;
  background: ${(props) => (props.$isNoticeboardPath ? '#704D94' : 'none')};
`
